import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";

/**
 * In-memory, per-session snapshot of the last DESC message list shown for a
 * thread. Lets reopening a chat visited earlier this session paint
 * SYNCHRONOUSLY (zero skeleton, zero blank frame) — faster than the async
 * IndexedDB read, which is the durable fallback. Cleared on full reload.
 */
const snapshots = new Map<string, Message[]>();

export function getMessageSnapshot(threadId: string | number): Message[] | undefined {
  return snapshots.get(String(threadId));
}

export function setMessageSnapshot(threadId: string | number, messages: Message[]): void {
  snapshots.set(String(threadId), messages);
}

export function clearMessageSnapshots(): void {
  snapshots.clear();
}
